import script from "./SortTable.vue?vue&type=script&lang=jsx"
export * from "./SortTable.vue?vue&type=script&lang=jsx"

import "./SortTable.vue?vue&type=style&index=0&id=38aa71c0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38aa71c0"]])

export default __exports__